export const textAlignLeft = {
  textAlign: 'left !important',
};

export const tableStyleObject = {
  table: {
    backgroundColor: '#fff',
    padding: '0',
    width: '100%',
    borderCollapse: 'separate',
    border: 'none !important',
  },
  table__aria_sort_none: {
    position: 'relative',
    whiteSpace: 'nowrap',
    '&::before': {
      transition: 'background-color 0.25S cubic-bezier(0.65, 0, 0.45, 1)',
      content: '""',
      height: '0.25rem',
      position: 'absolute',
      top: '-0.0625rem',
      left: '-0.0625rem',
      right: '-0.0625rem',
    },
    '&::after': {
      fontFamily: '"dls-icons-2.25.0"',
      content: '""',
      lineHeight: '1',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      fontSize: '0.75rem',
      color: '#c8c9c7',
      marginLeft: '0.625rem',
      display: 'inline-block',
      position: 'relative',
      transition: 'color 0.25S ease-out',
    },
  },
  table__aria_sort_descending: {
    position: 'relative',
    whiteSpace: 'nowrap',
    '&::before': {
      transition: 'background-color 0.25S cubic-bezier(0.65, 0, 0.45, 1)',
      content: '""',
      height: '0.25rem',
      position: 'absolute',
      top: '-0.0625rem',
      left: '-0.0625rem',
      right: '-0.0625rem',
    },
    '&::after': {
      fontFamily: '"dls-icons-2.25.0"',
      content: '""',
      lineHeight: '1',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      fontSize: '0.75rem',
      color: '#c8c9c7',
      marginLeft: '0.625rem',
      display: 'inline-block',
      position: 'relative',
      transition: 'color 0.25S ease-out',
    },
  },
  table__aria_sort_ascending: {
    position: 'relative',
    whiteSpace: 'nowrap',
    '&::before': {
      transition: 'background-color 0.25S cubic-bezier(0.65, 0, 0.45, 1)',
      content: '""',
      height: '0.25rem',
      position: 'absolute',
      top: '-0.0625rem',
      left: '-0.0625rem',
      right: '-0.0625rem',
    },
    '&::after': {
      fontFamily: '"dls-icons-2.25.0"',
      content: '""',
      lineHeight: '1',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      fontSize: '0.75rem',
      color: '#c8c9c7',
      marginLeft: '0.625rem',
      display: 'inline-block',
      position: 'relative',
      transition: 'color 0.25S ease-out',
      transform: 'rotate(180deg)',
    },
  },
  table__aria_sort_none__active: {
    color: '#00175a',
    '&::before': {
      backgroundColor: '#00175a',
    },
    '&::after': {
      color: '#00175a',
    },
  },
  table__aria_sort_descending__active: {
    color: '#00175a',
    '&::before': {
      backgroundColor: '#00175a',
    },
    '&::after': {
      color: '#00175a',
    },
  },
  table__aria_sort_ascending__active: {
    color: '#00175a',
    '&::before': {
      backgroundColor: '#00175a',
    },
    '&::after': {
      color: '#00175a',
    },
  },
  table__minWidthCell: {
    width: '1%',
  },
  table__checkable: {
    width: '1%',
    zIndex: '1',
    position: 'sticky',
    left: '0',
    backgroundColor: '#fff',
    borderRight: '0.0625rem solid #ecedee',
  },
  table__checkable__checkbox_label: {
    padding: '0',
  },
  table_th: {
    lineHeight: '1.375rem',
    borderBottom: '0.0625rem solid #ecedee',
    '&:first-of-type': {
      borderLeft: '0.0625rem solid #ecedee',
    },
    '&:last-of-type': {
      borderRight: '0.0625rem solid #ecedee',
    },
    padding: '0.9375rem 0.625rem 0.9375rem 0.625rem',
  },
  table_td: {
    lineHeight: '1.375rem',
    borderBottom: '0.0625rem solid #ecedee',
    '&:first-of-type': {
      borderLeft: '0.0625rem solid #ecedee',
    },
    '&:last-of-type': {
      borderRight: '0.0625rem solid #ecedee',
    },
    padding: '0.9375rem 0.625rem 0.9375rem 0.625rem',
  },
  table_tr: {
    '&:first-of-type th': {
      borderTop: '0.0625rem solid #ecedee',
    },
    '&:last-of-type td': {
      borderBottom: '0.0625rem solid #ecedee',
    },
  },
  table_thead: {
    backgroundColor: '#f7f8f9',
  },
  table_thead_th: {
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontWeight: '600',
    fontSize: '0.8125rem',
    lineHeight: '1.125rem',
    textTransform: 'uppercase',
    color: '#333',
  },
  table_thead__checkable: {
    backgroundColor: '#f7f8f9',
  },
  tableRowLink: {
    cursor: 'pointer',
    willChange: 'background-color',
    '&:hover': {
      backgroundColor: '#f7f8f9',
    },
    transition: 'background-color 0.15S ease-out',
  },
  tableStriped_tbody_tr: {
    '&:nth-of-type(even)': {
      backgroundColor: '#f7f8f9',
    },
  },
  tableStriped: {
    '&:not(.tableBordered) tr:not(:last-of-type) td': {
      borderBottom: 'none !important',
    },
  },
  tableBordered: {
    borderRight: '0.0625rem solid #ecedee',
  },
  tableBordered_th: {
    borderRight: '0.0625rem solid #ecedee',
  },
  tableBordered_td: {
    borderRight: '0.0625rem solid #ecedee',
  },
  table__expandableRow_th: {
    borderBottom: 'none',
  },
  table__expandableRow_td: {
    borderBottom: 'none',
  },
  table__expandableRow__collapsible: {
    outlineOffset: '-1px',
  },
  table__expandableRow__collapsibleCaret: {
    padding: '0',
  },
  table_td_expandedSection: {
    boxShadow: 'inset 0 0.0625rem #ecedee',
    padding: '0',
  },
  table_td_expand: {
    width: '1%',
    padding: '0',
  },
  table_td_expand__data_toggle_accordion: {
    padding: '0.9375rem',
    width: 'auto',
    '&:hover': {
      backgroundColor: 'unset',
    },
  },
  tableHover_tbody_tr: {
    transition: 'background-color 0.15S ease-out',
    willChange: 'background-color',
    '&:hover': {
      backgroundColor: '#f7f8f9',
    },
  },
  '@media (max-width: 374px)': {
    table_th: {
      padding: '0.625rem 0.3125rem 0.625rem 0.3125rem',
    },
    table_td: {
      padding: '0.625rem 0.3125rem 0.625rem 0.3125rem',
    },
    table__tdPad: {
      padding: '0.625rem 0.3125rem 0.625rem 0.3125rem',
    },
  },
  '@media (max-width: 767px)': {
    table_th: {
      padding: '0.625rem 0.375rem 0.625rem 0.375rem',
    },
    table_td: {
      padding: '0.625rem 0.375rem 0.625rem 0.375rem',
    },
    table__tdPad: {
      padding: '0.625rem 0.375rem 0.625rem 0.375rem',
    },
  },
  '@media (max-width: 1023px)': {
    table_th: {
      padding: '0.9375rem 0.5625rem 0.9375rem 0.5625rem',
    },
    table_td: {
      padding: '0.9375rem 0.5625rem 0.9375rem 0.5625rem',
    },
    table__tdPad: {
      padding: '0.9375rem 0.5625rem 0.9375rem 0.5625rem',
    },
  },
  '@media (max-width: 1279px)': {
    table_th: {
      padding: '0.9375rem 0.625rem 0.9375rem 0.625rem',
    },
    table_td: {
      padding: '0.9375rem 0.625rem 0.9375rem 0.625rem',
    },
    table__tdPad: {
      padding: '0.9375rem 0.625rem 0.9375rem 0.625rem',
    },
  },
  table__tdPad: {
    padding: '0.9375rem 0.625rem 0.9375rem 0.625rem',
  },
  tableSm_thead_th: {
    padding: '0.625rem 0.375rem 0.625rem 0.375rem',
  },
  tableSm_tr_td: {
    padding: '0.625rem 0.375rem 0.625rem 0.375rem',
  },
  disabledCheckboxRow: {
    color: 'rgb(51, 51, 51) !important',
  },
};
